import type { NavSectionProps } from 'src/components/nav-section';

import { useEffect } from 'react';

import Box from '@mui/material/Box';
import Drawer, { drawerClasses } from '@mui/material/Drawer';

import { usePathname } from 'src/routes/hooks';

import { Logo } from 'src/components/logo';
import { Scrollbar } from 'src/components/scrollbar';
import { NavSectionVertical } from 'src/components/nav-section';

import useAuth from 'src/auth/useAuth';

import { NavUserFooter } from '../components/nav-user-footer';
import { NavWalletBalanceWidget } from '../components/nav-wallet-balance-widget';
import { OrganizationsPopover } from '../components/organizations-popover';

// ----------------------------------------------------------------------

type NavMobileProps = NavSectionProps & {
  open: boolean;
  onClose: () => void;
  slots?: {
    topArea?: React.ReactNode;
    bottomArea?: React.ReactNode;
  };
};

export function NavMobile({ data, open, onClose, slots, sx, ...other }: NavMobileProps) {
  const { organizationId } = useAuth();
  const pathname = usePathname();

  useEffect(() => {
    if (open) {
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      sx={{
        [`& .${drawerClasses.paper}`]: {
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          bgcolor: 'var(--layout-nav-bg)',
          width: 'var(--layout-nav-mobile-width)',
          ...sx,
        },
      }}
    >
      {slots?.topArea ?? (
        <Box
          sx={{
            pl: 3.5,
            pr: 2,
            pt: 2.5,
            pb: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 2.5,
            minWidth: 0,
            flexShrink: 0,
          }}
        >
          <Logo />
          <OrganizationsPopover
            sx={{
              color: 'var(--layout-nav-text-primary-color)',
              minWidth: 0,
            }}
          />
        </Box>
      )}

      <Scrollbar fillContent sx={{ flex: '1 1 auto', minHeight: 0 }}>
        <NavSectionVertical data={data} sx={{ px: 2, flex: '1 1 auto' }} {...other} />
      </Scrollbar>

      {organizationId ? <NavWalletBalanceWidget organizationId={organizationId} /> : null}
      {slots?.bottomArea ?? <NavUserFooter />}
    </Drawer>
  );
}
